;(function () {
  'use strict'

  angular
    .module('contrast.app-environment')
    .directive('appEnvironment', appEnvironment)

  function appEnvironment() {
    return {
      restrict: 'E',
      scope: {
        data: '=',
        protectiondisable: '&',
        assessmentdisable: '&',
        isFreemium: '='
      },
      bindToController: true,
      controller: 'appEnvironmentCtrl',
      controllerAs: 'appEnvCtrl',
      templateUrl: 'components-org/app-environment/app-environment.html',
      link: function ($scope, element, attrs, ctrl) {
        $scope.$watch(function () {
          return ctrl.data.servers_protection
        }, ctrl.serverCountChange)
        $scope.$watch(function () {
          return ctrl.data.servers_assessment
        }, ctrl.serverCountChange)
        ctrl.activate()
      }
    }
  }
})()
